import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addResDataAction,
  saveLogin,
} from "../../redux/slices/mainDataSlice";
import Header from "../../components/header/Header";

const Home = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  const restaurantsData = useSelector((state) => state.main.data);

  const isAuth = useSelector((state) => state.main.isAuthenticated);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [addRes, setAddRes] = useState(false);
  useEffect(() => {
    if (!isAuth) {
      const storedUserCredentials = JSON.parse(
        localStorage.getItem("userCredentials")
      );
      if (storedUserCredentials) {
        dispatch(saveLogin(storedUserCredentials));
      } else {
        navigate("/");
      }
    }
  }, [isAuth, dispatch, navigate]);
  const [selectedResId] = useState(null);
  const [resImage, setResImage] = useState(null);
  const [resSrcImage, setResSrcImage] = useState(null);
  const [resName, setResName] = useState(null);
  const [resTheme, setResTheme] = useState(0);
  const [resUsername, setResUsername] = useState("");
  const [resPhone, setResPhone] = useState("");
  const [resPassword, setResPassword] = useState("");
  const [resStartDate, setResStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setResImage(reader.result);
      setResSrcImage(file);
    };
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const addYearToDate = (dateString) => {
    const date = new Date(dateString);
    date.setFullYear(date.getFullYear() + 1); // Add one year
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };
  const handleSave = () => {
    const data = {
      id: parseInt(selectedResId),
      res_name: resName,
      theme: resTheme,
      username: resUsername,
      phone: resPhone,
      password: resPassword,
      create_date: resStartDate,
      end_date: addYearToDate(resStartDate),
    };

    dispatch(
      addResDataAction({
        data,
        image: resSrcImage,
      })
    ).then(() => {
      // setResImage(``);
      setAddRes(false);
      setResSrcImage(null);
      setResImage("");
      setResTheme(0);
      setResName("");
      setResUsername("");
      setResPhone("");
      setResStartDate(new Date().toLocaleDateString("en-US"));
    });
  };
  return (
    <>
      <div className="admin-home-page">
        <Header text={"Super Admin"} isHome={true} />
        <div className="actions-box" data-aos="zoom-in">
          <div className={`button`} onClick={() => setAddRes(true)}>
            <i className="fa-solid fa-plus"></i>
            <div className="title">اضافة مطعم جديد</div>
          </div>
          <NavLink
            to="/admin/all-restaurants"
            className={({ isActive }) => `button ${isActive ? "active" : ""}`}
          >
            <i className="fa-solid fa-utensils"></i>
            <div className="title">المطاعم الحاليه</div>
          </NavLink>
        </div>

        <div className="res-count" data-aos="fade-in" data-delay="1000">
          <div className="title">عدد المطاعم</div>
          <div className="numbers">
            <div className="circle1"></div>
            <div className="circle2"></div>
            <div className="circle3"></div>
            <div className="number">{restaurantsData?.length}</div>
          </div>
        </div>
      </div>
      {addRes ? (
        <>
          <div className="add-res">
            <div
              className="layout"
              data-aos="fade-in"
              onClick={() => {
                setAddRes(false);
                setResSrcImage(null);
                setResImage("");
                setResTheme(0);
                setResName("");
                setResUsername("");
                setResPhone("");
                setResStartDate(new Date().toLocaleDateString("en-US"));
              }}
            ></div>
            <div className="info-box" data-aos="zoom-in">
              <React.Fragment>
                <div className="logo">
                  <img src={resImage} alt="" />
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id="upload"
                    onChange={handleImageUpload}
                  />
                  <label htmlFor="upload" className="edit-icon">
                    <i className="fa-solid fa-plus"></i>
                  </label>
                </div>
                <div className="group">
                  <input
                    type="text"
                    onChange={(e) => setResName(e.target.value)}
                    value={resName}
                  />
                </div>
                <div className="theme-group">
                  <div className="title">نوع النظــــــــام</div>
                  <div className="themes">
                    <div
                      className={`theme ${resTheme == "5" ? "active" : ""}`}
                      onClick={() => setResTheme("5")}
                    >
                      100
                    </div>
                    <div
                      className={`theme ${resTheme == "1" ? "active" : ""}`}
                      onClick={() => setResTheme("1")}
                    >
                      200
                    </div>
                    <div
                      className={`theme ${resTheme == "2" ? "active" : ""}`}
                      onClick={() => setResTheme("2")}
                    >
                      400
                    </div>
                    <div
                      className={`theme ${resTheme == "3" ? "active" : ""}`}
                      onClick={() => setResTheme("3")}
                    >
                      1000
                    </div>
                  </div>
                </div>
                <div className="group2">
                  <div className="title">أسم المستخدم</div>
                  <div className="group">
                    <input
                      type="text"
                      onChange={(e) => setResUsername(e.target.value)}
                      value={resUsername}
                    />
                  </div>
                </div>
                <div className="group2">
                  <div className="title">رقم الهاتف</div>
                  <div className="group">
                    <input
                      type="text"
                      onChange={(e) => setResPhone(e.target.value)}
                      value={resPhone}
                    />
                  </div>
                </div>
                <div className="group2">
                  <div className="title">كلمه المرور</div>
                  <div className="group">
                    <input
                      type="text"
                      onChange={(e) => setResPassword(e.target.value)}
                    />
                  </div>
                </div>
                <div className="end-date">
                  <div className="title">تاريــــــخ الأشتراك</div>
                  <input
                    type="date"
                    min={new Date().toISOString().split("T")[0]}
                    value={resStartDate}
                    onChange={(e) => setResStartDate(e.target.value)}
                  />
                </div>
                <div className="actions">
                  <div className="save-btn" onClick={handleSave}>
                    اضافه المطعم
                  </div>
                </div>
              </React.Fragment>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Home;
